import level3 from './assets/honest_level_3.svg';
import level4 from './assets/honest_level_4.svg';

export const HONEST_LEVEl_ICON: Record<number, string> = {
  [3]: level3,
  [4]: level4,
};
